import React from 'react';
import type { Showcase, ShowcaseProperty, ShowcaseResource } from '../../types';

interface DescriptionSectionProps {
  showcase: Showcase;
  property: ShowcaseProperty;
  resources: ShowcaseResource[];
  brandColour: string;
  darkMode?: boolean;
}

export default function DescriptionSection({ property, darkMode: dm }: DescriptionSectionProps) {
  if (!property.summary_description && !property.full_description) return null;

  return (
    <section className={`py-16 transition-colors duration-300 ${dm ? 'bg-slate-900' : 'bg-white'}`}>
      <div className="max-w-6xl mx-auto px-8">
        {property.summary_description && (
          <p className={`text-xl leading-relaxed mb-8 font-light ${dm ? 'text-slate-300' : 'text-slate-600'}`}>
            {property.summary_description}
          </p>
        )}
        {property.full_description && (
          <div className={`prose max-w-none leading-relaxed whitespace-pre-line ${dm ? 'text-slate-300' : 'prose-slate text-slate-700'}`}>
            {property.full_description}
          </div>
        )}
      </div>
    </section>
  );
}
